import con from '../../../../connection';

const path = '/settings';

const settings = (url: string) => (planId: string, applicationId: number) => ({
  get: () => con.get(url + '/' + planId + '/' + applicationId + path, {}),
  post: (param: { param: string}) => con.post(url + '/' + planId + '/' + applicationId + path, param),
});

export default settings;